import Service from "../../AuthService";
const Employee = {
    getEmployee(page) {
        return Service.get("/employee?page="+page);
    },
    showEmployee(id) {
        return Service.get("/employee/" + id);
    },
    updateEmployee(id, data) {
        return Service.put("/employee/" + id, data);
    },
    updateSalaryEmployee(data) {
        return Service.post("/updateSalaryEmployee", data);
    },
    createEmployee(data) {
        return Service.post("/employee", data);
    },
    deleteEmployee(id) {
        return Service.delete("/employee/" + id);
    },
    getEmployeeAll(){
        return Service.get("/employee-all");
    },
    getEmployeeAll_data(){
        return Service.get("/employee-all-data");
    },
    getTypeList(){
        return Service.get("/listcostemployeeother");
    },
    getTypeListIncome(){
        return Service.get("/listincomeemployeeother");
    },
    searchEmployee(data){
        return Service.post("/employee-search",data)
    },
    searchPaymentSalary(data){
        return Service.post("/employee-salary-search",data)
    },
    filterEmployee(page,status) {
        return Service.get("employee-filter?page=" + page +
            "&status=" + status);
    },
    uploadFilePDF(data){
        return Service.post("/employee-upload-file",data);
    },
    Payroll(data){
        return Service.post("/getPayroll",data);
    },
    validatePassportNumber(citizen_id){
        return Service.get("/validate_passport?citizen_id="+citizen_id);
    },
    approveEmployee(data){
        return Service.post('/update_approve_employee',data);
    },
    approveResignEmployee(data){
        return Service.get('/update_approve_resign_employee?id='+data.id+'&user='+data.user);
    },
    validateEmployeeNo(employee_no) {
        return Service.get('/validate_employee_no?employee_no='+employee_no)
    },
    //slip salary
    previewSalaryPDF(data){
        return Service.get("/preview-salary-pdf?week=" +data.week+
            "&date="+data.date+
            "&name="+data.name+
            "&employee_id="+data.employee_no+
            "&department_id="+data.department_id,)
    },
    exportSlipSalaryEmployee(data){
        return Service.get(`DisplaySalaryEmployee?week=${data.week}&month=${data.month}&department=${data.department}&employee_no=${data.employee_no}&lang=${data.lang}`)
    },
    exportExpireEmployee(data){
        let id_employee = '';
        let id_department = '';
        data.employee_no.forEach((a,i)=>{
            data.employee_no.length == i+1 ? id_employee = id_employee + a.id:id_employee = id_employee + a.id + ',';
        })
        data.department_id.forEach((a,i)=>{
            data.department_id.length == i+1 ? id_department = id_department + a.id:id_department = id_department + a.id + ',';
        })
        return Service.get(`ExpireEmployee?type_view=${data.type_view}&department_id=${id_department}&date=${data.date}&employee_no=${id_employee}&passport_type_id=${data.passport_type_id}`)
    },
    addNation(data){
        return Service.get(`add_passport_type?nation=${data.nation}`)
    },
    deleteNation(data){
        return Service.get(`delete_passport_type?nation=${data.nation}`)
    },
    detailSalary(id){
        return Service.get("/rate_salary_history_detail?id="+id);
    },
    updateSalary(data){
        return Service.put("/rate_salary_history/" + data.id, data);
    },
    deleteSalary(id){
        return Service.delete("/rate_salary_history/" + id);
    },
    approveSalary(data){
        return Service.get(`/rate_salary_approve?id=${data.id}&user_id=${data.user_id}`);
    }
};
export default Employee;
